<template>
  <div>
    <v-container class="tipo-problema__container">
      <title-ribbon v-bind="{ title: tipoProblema.nombre }" />
      <div
        v-if="charged"
        class="tipo-problema_container__main"
      >
        <v-row class="tipo-problema_row__img">
          <v-col>
            <v-img
              :src="`https://res.cloudinary.com/dkod5pdlc/image/upload/f_auto,q_auto/v${ cldVersion }/terapiacl/tipos-problemas/${ tipoProblema.imagen }`"
            />
          </v-col>
        </v-row>
        <splitter />
        <v-row class="tipo-problema_row__principal mb-4">
          <v-col>
            <v-row>
              <v-col class="col-12 col-md-9 mainview">
                <v-row class="mainview-descripcion">
                  <v-col class="md-text">
                    <p v-html="tipoProblema.descripcion" />
                  </v-col>
                </v-row>
                <v-row class="mainview-divider">
                  <v-col class="md-divider">
                    <div class="divider" />
                  </v-col>
                </v-row>
                <div v-if="tipoProblema.causas">
                  <v-row>
                    <v-col>
                      <splitter-title
                        v-bind="{
                          color: 1,
                          title: tipoProblema.causasTitulo,
                        }"
                      />
                    </v-col>
                  </v-row>
                  <v-row class="mainview-tratamiento">
                    <v-col>
                      <p v-html="tipoProblema.causas" />
                    </v-col>
                  </v-row>
                </div>
                <div v-if="tipoProblema.tratamiento">
                  <v-row>
                    <v-col>
                      <splitter-title
                        v-bind="{
                          color: 1,
                          title: tipoProblema.tratamientoTitulo,
                        }"
                      />
                    </v-col>
                  </v-row>
                  <v-row class="mainview-tratamiento">
                    <v-col>
                      <p v-html="tipoProblema.tratamiento" />
                    </v-col>
                  </v-row>
                </div>
                <v-row class="mainview-problemas">
                  <v-col class="md-principal">
                    <div class="principal">
                      <div class="up">
                        <h3>{{ tipoProblema.problemasTitulo }}:</h3>
                      </div>
                      <ul>
                        <li
                          v-for="(problema, p) in problemas"
                          :key="p"
                        >
                          <router-link :to="`/problema/${problema.toLink}`">
                            {{ problema.nombre }}
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="col-12 col-md-3 sideview">
                <!-- <h3>Reserva tu Hora</h3> -->
                <v-btn
                  color="success"
                  href="https://horasonline.terapia.cl/"
                  target="_blank"
                >
                  Reserva tu Hora
                </v-btn>
                <div>
                  <h3>Otros Problemas que Atendemos:</h3>
                  <ul>
                    <li
                      v-for="(item, i) in tipoProblemaOtros"
                      :key="i"
                    >
                      <router-link :to="`/problemas/${item.ToLink}`">
                        {{ item.NombreTipoProblema }}
                      </router-link>
                    </li>
                  </ul>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <splitter />
        <message-ribbon
          v-bind="{
            atenderseSucursales: true,
          }"
        />

        <splitter-volver />
      </div>
      <div v-else>
        <v-row>
          <v-col class="text-center">
            <v-progress-circular
              :size="70"
              :width="7"
              color="success"
              indeterminate
            />
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { mapState } from 'vuex'
  import mixins from '../../mixins'
  export default {
    name: 'Especialidad',
    components: {
      TitleRibbon: () => import('@/components/web/base/TitleRibbon'),
      MessageRibbon: () => import('@/components/web/base/MessageRibbon'),
      Splitter: () => import('@/components/web/base/Splitter'),
      SplitterTitle: () => import('@/components/web/base/SplitterTitle'),
      SplitterVolver: () => import('@/components/web/base/SplitterVolver'),
    },
    mixins: [mixins],
    data: function () {
      return {
        tipoProblema: '',
        problemas: '',
        tipoProblemaOtros: '',
        charged: false,
      }
    },
    computed: {
      ...mapState('web', ['cldVersion', 'sucursales']),
    },
    watch: {
      '$route.params.toLink': {
        handler: function (toLink) {
          this.getTipoProblema(toLink)
        },
      },
    },
    created () {
      this.getTipoProblema(this.$route.params.toLink)
    },
    methods: {
      getTipoProblema (toLink) {
        this.charged = false
        this.tipoProblema = ''
        this.problemas = ''
        this.tipoProblemaOtros = ''

        Vue.axios
          .post('/problemas-tipos/tipo', { toLink })
          .then(response => {
            this.tipoProblema = response.data.tipoProblema
            this.problemas = response.data.otros.problemas
            this.tipoProblemaOtros = response.data.otros.tipoProblemaOtros
            this.charged = true
          })
          .catch(error => {
            console.log(error)
          })
      },
    },
    metaInfo () {
      return {
        title: this.tipoProblema.metaTitle
          ? this.tipoProblema.metaTitle
          : ' ... ',
        titleTemplate: '%s | Centro de Terapia del Comportamiento',
        htmlAttrs: {
          lang: 'es',
          amp: true,
        },
        meta: this.tipoProblema.metaTags ? this.tipoProblema.metaTags : [],
      }
    },
  }
</script>

<style>
.tipo-problema_container {
  padding: 50px !important;
  text-align: center;
}
</style>
